import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSharedService} from '../../services/get-config-shared.service';
import {select, Store} from '@ngrx/store';
import * as fromCompanies from '../../../company/reducers';
import {SelectedItem} from '../../../order/models/order';
import * as fromShared from '../../reducers';
import {Router} from '@angular/router';
import {EndBillingActionComplex} from '../../actions/subscription-close';
import {ClearOneItemSubListAction, ClearSubListAction} from '../../actions/subscription-list';
import * as fromRoot from '../../reducers';
import * as moment from 'moment';
import * as _ from 'lodash';
import {CommonField} from '../../models/common-field';
import {ModalComponent} from '@storever/modal-confirmation';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-close-billing-subscrption',
  templateUrl: './close-billing-subscription.component.html',
  styleUrls: ['./close-billing-subscription.component.scss']
})
export class CloseBillingSubscriptionComponent implements OnInit, OnDestroy {
  @ViewChild('staticModal' , {static: false}) public staticModal: ModalDirective;
  private sub$: Subscription;
  private subscriptions = [];
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  myForm: FormGroup;
  formConfig: GroupConfig;
  error = 'false';
  errorName = 'false';
  companyUuid: string;
  contractUuid: string;
  billedUpMsg: string;
  endUpMsg = 'false';
  endUpCloseMsg = 'false';
  selectedSub: CommonField [] = [];
  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private storeCompany: Store<fromCompanies.AppState>,
              private store: Store<fromShared.AppState>,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private bsModalRefConfirmation: BsModalRef,
              private modalService: BsModalService,
              private storeRoot: Store<fromRoot.AppState>,
              private bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.myForm = this.getFormsService.closeSubscription();

    this.clearValidatorIfStartDate();
    this.getCompanyAndContractData();
    this.selectedItem$ = this.storeRoot.pipe(select(fromRoot.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      this.endUpCloseMsg = 'false';
      this.endUpMsg = 'false';
      let first = true;
      if (data) {
        this.selectedItem = data;
        if (this.selectedItem && this.selectedItem.length > 0) {
          let billedUpStatus = false;
          let billedUpDate;
          for (let c = 0; c < this.selectedItem.length; c++) {
            this.selectedSub.push({name: this.selectedItem[c].name , uuid: this.selectedItem[c].uuid  });
            if (this.selectedItem[c].billedUp) {
              billedUpStatus = true;
              billedUpDate = this.selectedItem[c].billedUp;

            }
            if (this.selectedItem[c].status === 1 && (moment(this.selectedItem[c].end).year() < new Date().getFullYear()) ) {
              this.endUpCloseMsg = 'Some of your subscriptions are closed you are not allow  to update end billing date of them';
              first = false
            }

            if (this.selectedItem[c].status === 1 && (moment(this.selectedItem[c].end).year() === new Date().getFullYear()) && first && this.endUpCloseMsg === 'false') {
              this.endUpMsg = 'These subscriptions have already a end date';
            }
          }
          // if (billedUpStatus) {
          //   this.formConfig = this.getConfigSharedService.closeSubscriptionDetail();
          //   this.formConfig.config[1].options.datePicker.numberDelayDays = 1 + moment(billedUpDate, 'YYYY-MM-DD HH:mm:ss').diff(new Date() , 'days');
          //   this.formConfig.config[1].options.datePicker.minDate = true;
          //   this.myForm.get(['startBilling']).clearValidators();
          //   this.myForm.get(['startBilling']).updateValueAndValidity();
          // } else {
          //   this.myForm.get(['startBilling']).setValidators([Validators.required]);
          //   this.formConfig = this.getConfigSharedService.closeSubscription();
          // }
          this.checkBilUpDate(billedUpDate);
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.storeRoot.pipe(select(fromRoot.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        // if (this.selectedOneItem.start) {
        //   this.myForm = this.getFormsService.closeSubscriptionWithoutValidator();
        // }
       // this.myForm.patchValue({startBilling : this.selectedOneItem.start})
       // this.myForm.patchValue({endBilling : this.selectedOneItem.end})
        // if (this.selectedOneItem.billedUp) {
        //   this.formConfig = this.getConfigSharedService.closeSubscriptionDetail();
        //   this.formConfig.config[1].options.datePicker.numberDelayDays = 1
        //   + moment(this.selectedOneItem.billedUp , 'YYYY-MM-DD HH:mm:ss').diff(new Date() , 'days');
        //   this.formConfig.config[1].options.datePicker.minDate = true;
        //   this.myForm.get(['startBilling']).clearValidators();
        //   this.myForm.get(['startBilling']).updateValueAndValidity();
        // } else {
        //   this.formConfig = this.getConfigSharedService.closeSubscription();
        //   this.myForm.get(['startBilling']).setValidators([Validators.required]);
        // }
        this.checkBilUpDate(this.selectedOneItem.billedUp);
      }

    });
    this.subscriptions.push(this.sub$);
    this.patchForm();
    this.checkValidityDate();
  }

  // tslint:disable-next-line:no-any
  checkBilUpDate(billedUp: any): void {
    if (billedUp) {
     // this.formConfig = this.getConfigSharedService.closeSubscriptionDetail();
      this.formConfig = this.getConfigSharedService.closeSubscription();
     // this.formConfig.config[1].options.datePicker.numberDelayDays = 1 + moment(billedUp, 'YYYY-MM-DD HH:mm:ss').diff(new Date() , 'days');
     // this.formConfig.config[1].options.datePicker.minDate = true;
      this.formConfig.config[0].options.datePicker.numberDelayDays = 2 + moment(billedUp, 'YYYY-MM-DD HH:mm:ss').diff(new Date() , 'days') ;
      this.formConfig.config[0].options.datePicker.minDate = true;
      this.billedUpMsg = billedUp;
      // this.myForm.get(['startBilling']).clearValidators();
      // this.myForm.get(['startBilling']).updateValueAndValidity();
    } else {
      this.formConfig = this.getConfigSharedService.closeSubscription();
      this.billedUpMsg = null;
      // this.myForm.get(['startBilling']).setValidators([Validators.required]);
    }
  }
  clearValidatorIfStartDate(): void {
      this.sub$ = this.myForm.get('startBilling').valueChanges.subscribe((data) => {
        if (data && data !== 'Invalid date') {
            this.myForm.get('endBilling').clearValidators();
            this.myForm.get('endBilling').updateValueAndValidity();
          } else {
            this.myForm.get('endBilling').setValidators([Validators.required]);
            this.myForm.get('endBilling').updateValueAndValidity();
          }

      })
      this.subscriptions.push(this.sub$);
   }
  checkValidityDate(): void {
    this.sub$ = this.myForm.valueChanges.subscribe((data) => {
      // if (data) {
      //   if (data.startBilling) {
      //     this.myForm = this.getFormsService.closeSubscriptionWithoutValidator();
      //     // this.myForm.get('endBilling').clearValidators();
      //     // this.myForm.get('endBilling').updateValueAndValidity();
      //   } else {
      //     // this.myForm.get('endBilling').setValidators([Validators.required]);
      //     // this.myForm.get('endBilling').updateValueAndValidity();
      //     this.myForm = this.getFormsService.closeSubscription();
      //   }
      // }
      // if (data.endBilling !== 'Invalid date' && data.startBilling !== 'Invalid date') {
      //   console.log('if 1');
      //   this.error = 'false';
      //   this.updateErrorDate(data.startBilling, data.endBilling);
      // }
      if (data.endBilling !== 'Invalid date' && this.selectedOneItem && this.selectedOneItem.start) {
        this.error = 'false';
        this.updateErrorDate(( data.startBilling && (data.startBilling  !== 'Invalid date'))
          ? data.startBilling : this.selectedOneItem.start, data.endBilling);
      }
      if (data.endBilling !== 'Invalid date' && this.selectedItem.length > 0 ) {
        for (let c = 0; c < this.selectedItem.length; c++) {
          this.error = 'false';
          this.updateErrorDate((data.startBilling && (data.startBilling  !== 'Invalid date'))
            ? data.startBilling : this.selectedItem[0].start, data.endBilling);
        }
      }
    })
    this.subscriptions.push(this.sub$);
  }

  updateErrorDate(start: string , end: string): void {
      if (start && end && !moment(start).isBefore(end)) {
        this.error = 'End date must be bigger than the start date';
      }
  }
  ngOnDestroy(): void {
    this.store.dispatch(new  ClearOneItemSubListAction());
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  patchForm(): void {

  }

  // this fonction is used when we call this modal via data table
  closeBSF(): void {
    this.store.dispatch(new  ClearOneItemSubListAction());
    this.selectedOneItem = null;
    this.selectedSub = [];
    this.companyUuid = null;
    this.contractUuid = null;
    this.endUpCloseMsg = 'false';
    this.endUpMsg = 'false';
    this.bsModalRef.hide();
  }

  open(): void {
    this.staticModal.show();
  }

  // tslint:disable-next-line:no-any
  send(value: any): void {
    if (value.endBilling === undefined) {
      value.endBilling = '2099-12-31'
    }
    const initialState = {
      title: 'CONFIRMATION',
      message: 'Are you sure you want to put this End billing date ?  This will create an inconsistency with the invoicing. A credit note may be necessary. An email will be send to the Finance team.',
      variable: null,
      deleteBtn: false,
      hideBtnOk: true
    };
    // @ts-ignore
    if (this.billedUpMsg) {
      this.bsModalRefConfirmation = this.modalService.show(ModalComponent, {initialState});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe((modal) => {
        if (this.bsModalRefConfirmation.content.isConfirmed && (this.selectedItem.length > 0 || this.selectedOneItem)) {
          this.sendAction(value);
        }
      });
    } else {
      this.sendAction(value);
    }


  }

  // tslint:disable-next-line:no-any
  sendAction(value: any): void {
     if (this.selectedOneItem) {
        this.store.dispatch(new EndBillingActionComplex (
          {'subscriptionsTimeLinkBulk': [
              {
                'subscription': {
                  'Uuid': this.selectedOneItem.uuid
                },
                'company': {
                  'Uuid': this.selectedOneItem.companyUuid
                },
                'contract': {
                  'Uuid': this.selectedOneItem.contractUuid
                },
                'startBilling':  value.startBilling && value.startBilling !== 'Invalid date' ?
                  moment(value.startBilling).format('YYYY-MM-DD[T]HH:mm:ss') :
                  moment(this.selectedOneItem.start).format('YYYY-MM-DD[T]HH:mm:ss'),
                'endBilling': moment(value.endBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
              }] ,
           'comment': value.comment},
          )
        )

      } else {
        const subscriptionsTimeLinkBulk = [];
        for (let c = 0; c < this.selectedItem.length; c++) {
          subscriptionsTimeLinkBulk.push({
            'subscription': {
              'Uuid': this.selectedItem[c].uuid
            },
            'company': {
              'Uuid': this.selectedItem[c].companyUuid
            },
            'contract': {
              'Uuid': this.selectedItem[c].contractUuid
            },
            'startBilling':  value.startBilling && value.startBilling !== 'Invalid date' ?
              moment(value.startBilling).format('YYYY-MM-DD[T]HH:mm:ss') :
              moment(this.selectedItem[c].start).format('YYYY-MM-DD[T]HH:mm:ss'),
            'endBilling':  moment(value.endBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
          });
        }
        this.store.dispatch(new EndBillingActionComplex (
          {'subscriptionsTimeLinkBulk': subscriptionsTimeLinkBulk , comment: value.comment}))
      }
     this.storeCompany.dispatch(new ClearSubListAction());
     this.storeCompany.dispatch(new ClearOneItemSubListAction());
     this.closeBSF();
  }
  removeItem(index: number): void {
    this.endUpCloseMsg = 'false';
    this.endUpMsg = 'false';
    let first = true;
    if (this.selectedItem.length > 1) {
      let selectedItemTemp;
      selectedItemTemp = _.cloneDeep(this.selectedItem);
      if (index > -1) {
        selectedItemTemp.splice(index, 1);
      }
      this.selectedItem = selectedItemTemp;
      this.selectedSub = selectedItemTemp;
      let billedUpDate;
      for (let c = 0; c < this.selectedItem.length; c++) {
        if (this.selectedItem[c].billedUp) {
        billedUpDate = this.selectedItem[c].billedUp;
       }
        if (this.selectedItem[c].status === 1 && (moment(this.selectedItem[c].end).year() < new Date().getFullYear()) ) {
          this.endUpCloseMsg = 'Some of your subscriptions are closed you are not allow  to update end billing date of them';
          first = false
        }

        if (this.selectedItem[c].status === 1 && (moment(this.selectedItem[c].end).year() === new Date().getFullYear()) && first && this.endUpCloseMsg === 'false') {
          this.endUpMsg = 'These subscriptions have already a end date';
        }
      }
      this.checkBilUpDate(billedUpDate);

    }

  }
  checkEndDateStatus(item: SelectedItem): boolean {
    if (item.status === 1 && (moment(item.end).year() < new Date().getFullYear()) ) {
      return true;
    } else {
      return false;
    }
  }

  getCompanyAndContractData(): void {
    this.companyUuid =  this.router.url.split('?')[0].split('/')[1];
    this.contractUuid =  this.router.url.split('?')[0].split('/')[4];
  }
}
